export default ($axios) => ({
    $axios,

    async daily(query) {
        return await $axios.get(`/metrics/daily${query}`, {
            headers: {
                'X-Features': 'NEW_METRICS',
            },
        })
    },

    async month(query) {
        return await $axios.get(`/metrics/month${query}`)
    },
})
